import moment from "moment-timezone";

export const adminPermissions = [
  "profile",
  "change_password",
  "subadmins",
  "coin_list",
  "statistics",
  "manage_users",
  "view_users",
  "game_history",
  "view_game_history",
  "leaderboard",
  "claim_history",
  "logs",
  "tasks",
  "roadmap",
  "add_roadmap",
  "edit_roadmap",
  "delete_roadmap",
  "add_task",
  "edit_task",
  "delete_task",
  "edit_leaderboard_points",
  "edit_game_settings",
  "edit_leaderboard_settings",
  "edit_energy_settings",
  "edit_maintenance_settings",
  "edit_users",
  "game_settings",
  "leaderboard_settings",
  "energy_settings",
  "maintenance_settings",
  "welcome_bonus_settings",
  "edit_welcome_bonus_settings",
  "crypto_exchange_settings",
  "edit_crypto_exchange_settings",
  "edit_conversion_settings",
  "conversion_settings",
  "promotion_settings",
  "edit_promotion_settings",
  "crypto_deposit_settings",
  "edit_crypto_deposit_settings",
  "energy_package",
  "view_energy_package",
  "add_energy_package",
  "edit_energy_package",
  "delete_energy_package",
  "payment_setting",
  "edit_payment_setting",
  "buy_energy_setting",
  "edit_buy_energy_setting",
  "energy_purchase_history",
  "view_energy_purchase_history",
  "reward_system_settings",
  "edit_reward_system_settings",
  "edit_jackpot_settings",
  "jackpot_settings",
  "jackpot_history",
  "weekly_reward_history",
  "language_settings",
  "update_user_balance",
  "edit_language_settings",
  "historical_data_setting",
  "edit_historical_data_setting",
  "move_data_mySql",
  "remove_data_mongoDb",
  "delete_data_from_mongoDb",
  "round_multiplier",
  "add_round_multiplier",
  "edit_round_multiplier",
  "delete_round_multiplier",
  "system_announcement",
  "add_system_announcement",
  "view_system_announcement",
  "export_request",
  "download_export_request",
  "coin_history",
  "add_role",
  "edit_role",
  "view_role",
  "delete_role",
  "add_permission",
  "edit_permission",
  "view_permission",
  "delete_permission",
  "add_permission_meta",
  "edit_permission_meta",
  "view_permission_meta",
  "delete_permission_meta",
  "add_admin",
  "view_admin",
  "edit_admin",
  "delete_admin"
];

// Function to generate week options
export const generateWeekDayOptions = () => {
  const options = [
    { value: "", label: "All Days" }, // 👈 add this
  ];

  for (let i = 1; i <= 7; i++) {
    options.push({ value: i, label: `Day ${i}` });
  }

  return options;
};

export const generateWeekOptions = (timezone) => {
  const now = moment().tz(timezone);
  const totalWeeks = now.isoWeeksInYear();
  const options = [];

  for (let i = 1; i <= totalWeeks; i++) {
    options.push({ value: i, label: `Week ${i}` });
  }

  return options;
};

export const generateYearOptions = () => {
  const startYear = 2024;
  const endYear = 2100;
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push({ value: year, label: year.toString() });
  }
  return years;
};

// export const getWeeksInYearForOffset = () => {
//     // Get current year dynamically
//     const year = new Date().getFullYear(); // Current year

//     // Define the timezone (Etc/GMT-4 represents GMT+4)
//     const timezone = "Etc/GMT-4";

//     // Get the last day of the current year in the specified timezone
//     const lastDayOfYear = moment.tz(`${year}-12-31`, timezone);

//     // Get the first day of the next year
//     const firstDayOfNextYear = moment.tz(`${year + 1}-01-01`, timezone);

//     // Get the number of days in the last week of the current year (Dec 29 to Dec 31)
//     const lastWeekDaysInCurrentYear = [
//         lastDayOfYear.clone().subtract(2, 'days'),
//         lastDayOfYear.clone().subtract(1, 'days'),
//         lastDayOfYear
//     ];

//     // Check if the last days of December belong to Week 53 of the current year
//     const daysInLastWeek = lastWeekDaysInCurrentYear.filter(day => day.year() === year).length;

//     // If the last days of December (2 or 3 days) are part of the current year, add Week 53
//     const totalWeeks = (daysInLastWeek >= 1) ? 53 : 52;  // Ensure that even 1 day in the last week counts as Week 53

//     const weeks = [];

//     // Add Week 53 if applicable
//     if (totalWeeks === 53) {
//         weeks.push({ value: 53, label: "Week 53" });
//     }

//     // Add the regular weeks from Week 1 to Week 52 (or 53)
//     for (let i = 1;i <= totalWeeks - 1;i++) {
//         weeks.push({ value: i, label: `Week ${i}` });
//     }

//     // Only add Week 1 for next year if it is not already part of the current year
//     // if (totalWeeks === 53) {
//     //     weeks.push({ value: 1, label: "Week 1" });
//     // }

//     // Sort the weeks array in ascending order
//     weeks.sort((a, b) => a.value - b.value);

//     return weeks;
// };
